import { SiteLayout, PageBanner } from "../components/site/SiteLayout";
import { ContactSection } from "../components/site/Sections2";
import { usePrefs } from "../context/PrefsContext";

export default function Hubungi() {
  const { t } = usePrefs();
  return (
    <SiteLayout>
      {(content) => (
        <div data-testid="hubungi-page">
          <PageBanner title={t.nav.contact} subtitle={t.banner.contactSub} image={content.page_banners?.contact?.image} video={content.page_banners?.contact?.video} posY={content.page_banners?.contact?.pos_y} />
          <ContactSection contact={content.contact} services={content.services} />
        </div>
      )}
    </SiteLayout>
  );
}
